﻿'use strict';

angular.module('ntmApp')
  .factory('TALocationService', ['$location', function ($location) {

      function goToTheHomePage() {
          $location.path('/todaysAssignments');
      }

      function goToTheRoomGroups(facilityCode, roomNumber) {
          $location.path('/todaysAssignments/room/' + facilityCode + '/' + roomNumber);
      }

      function goToTheActivityDetails(scheduleId) {
          //rework this?
          $location.path(scheduleId ? '/todaysAssignments/activity/' + scheduleId : '/todaysAssignments/activity');
      }

      function goToTheRackCensus(facilityId, roomId) {
          $location.path('/todaysAssignments/roomRackCensus/' + facilityId + '/' + roomId);
      }

      function goToThePreparationList(facilityId, roomId) {
          if (facilityId && roomId) {
              $location.path('/todaysAssignments/preparationList/' + facilityId + '/' + roomId);
          } else {
              $location.path('/todaysAssignments/preparationList');
          }
      }

      var service = {};

      service.GoToTheHomePage = goToTheHomePage;
      service.GoToTheRoomGroups = goToTheRoomGroups;
      service.GoToTheActivityDetails = goToTheActivityDetails;
      service.GoToTheRackCensus = goToTheRackCensus;
      service.GoToThePreparationList = goToThePreparationList;

      return service;
  }]);
